import { render, staticRenderFns } from "./pdfInvoice.vue?vue&type=template&id=5cac87c5&"
import script from "./pdfInvoice.vue?vue&type=script&lang=js&"
export * from "./pdfInvoice.vue?vue&type=script&lang=js&"
import style0 from "./pdfInvoice.vue?vue&type=style&index=0&id=5cac87c5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports